export default {
  title01: "Obecna Pogoda",
  title02: "24 godz.",
  title03: "Zobacz 10-dniową prognozę pogody",
  title04: "AQI",
  title05: "Zobacz wszystkie informacje",
  title06: "WSCHÓD I ZACHÓD SŁOŃCA",
  title07: "FAZA KSIĘŻYCA",
  title08: "Następna pełnia Księżyca",
  title09: "Następny nów Księżyca",
  title10: "DZIEŃ",
  title11: "NOC",
  title12: "Wschód Słońca",
  title13: "Zachód Słońća",
  title14: "Wschód Księżyca",
  title15: "Zachód Księżyca",
  title16: "Źródło",
  title17: "Początek",
  title18: "Koniec",
  title19: "Użyj obecnej lokalizacji",
  title20: "Szukaj miasta",
  title21: "Odczucie",
  title22: "Odczucie w cieniu",
  title23: "Teraz",
  title24: "Dziś",
  title25: "Niedz",
  title26: "Pon",
  title27: "Wt",
  title28: "Śr",
  title29: "Czw",
  title30: "Pt",
  title31: "Sob",
  title32: "Wczytywanie...",
  title33: "Teraz",
  title34: "Prognoza godzinowa",
  title35: "Codzienna prognoza",
  title36: "Słońce i Księżyc",
  title37: "Jakość powietrza",
  title38: "Kontakt pod adresem: xlf550402@gmail.com",
  title39: "Umowa o ochronie prywatności",
  title40: "Copyright © comfortweather.com 2020 - 2025. Wszelkie prawa zastrzeżone.",
  title41: "Dane dostarczone przez",
  title42: "Wys",
  title43: "Nis",
  title44: "Akceptuj",
  title45:
    "Dziękujemy za korzystanie z ComfortWeather! Aby lepiej chronić swoje prawa i interesy, prosimy o uważne przeczytanie ",
  title46: "Polityki prywatności",
  title47: " przed rozpoczęciem korzystania z serwisu.",
  title48: "",
  title49: "Kontakt pod adresem: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. Wszelkie prawa zastrzeżone.",
  title51:
    "Dziękujemy za korzystanie z 24hweather! Aby lepiej chronić swoje prawa i interesy, prosimy o uważne przeczytanie ",
};
